// extracted by mini-css-extract-plugin
export default {"author_admin":"AdminPage_author_admin__YUPoN","publicationsAdmin":"AdminPage_publicationsAdmin__aaW4R"};